module.exports = __webpack_public_path__ + "img/4.89fc7f38.png";